import { ReactElement, useEffect } from "react";
import { useDynamicPageMeta } from "../../hooks/useDynamicPageMeta";
import "../../assets/css/disclaimer.css";
import DisclaimerBanner from "./components/DisclaimerBanner";
import DisclaimerBody from "./components/DisclaimerBody";

export default function DisclaimerPage(): ReactElement {
  const { setPageMeta, clearPageMeta } = useDynamicPageMeta();

  useEffect(() => {
    document.title = "WSG: Disclaimer";
    setPageMeta({
      breadcrumbLabels: { "/disclaimer": "Disclaimer" },
    });
    return () => {
      clearPageMeta();
    };
  }, [clearPageMeta, setPageMeta]);

  return (
    <div className="disclaimer-page">
      <div className="disclaimer-hero" aria-hidden="true" />
      <DisclaimerBanner />
      <DisclaimerBody />
    </div>
  );
}
